import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Tabs, type TabsProperties } from 'ui';
import { mapCommunityTabToPathName } from '../utilities';

export type CommunityTabItem = '/about' | '/assets' | '/feed' | '/members';

type P = {
  active: CommunityTabItem;
  communityId: string;
  isPublicView: boolean;
  showMembers?: boolean;
};

const CommunityTabs = ({ active, communityId, isPublicView, showMembers = true }: P) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onTabClick = useCallback(
    async (key: string) => {
      // TODO: This should not be in feature
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      await navigate(mapCommunityTabToPathName(communityId, key as CommunityTabItem));
    },
    [communityId, navigate],
  );

  const tabItems = useMemo(() => {
    const items: TabsProperties['items'] = [];

    if (!isPublicView) {
      items.push({ key: '/feed', label: t('News') });
      if (showMembers) {
        items.push({ key: '/members', label: t('Members') });
      }
      items.push({ key: '/assets', label: t('Files') });
    }

    items.push({ key: '/about', label: t('About') });

    return items;
  }, [isPublicView, showMembers, t]);

  return (
    <Tabs
      activeKey={active}
      animated={{ inkBar: false }}
      className="community-tabs"
      hasContentHolderHidden
      items={tabItems}
      onTabClick={onTabClick}
    />
  );
};

export default CommunityTabs;
